module.exports = __webpack_public_path__ + "media/components/assets/icons/colon-c187ca11d9b8254c802fb15b0f2861f6.svg";